import type { TimePickerDisplayMode, TimePickerProps as TimePickerNewProps } from './TimePicker';
import type { TimeRangePickerProps as TimeRangePickerNewProps } from './TimeRangePicker';

export type OldTimePickerDisplayMode = 'popover' | 'bottomSheet';

export interface OldTimePickerProps extends Omit<TimePickerNewProps, 'status' | 'displayMode' | 'hasRemoveButton'> {
  /** @deprecated status를 대신 사용해주세요. */
  error?: boolean;
  /** @deprecated displayMode='bottom-sheet'를 대신 사용해주세요. */
  displayMode?: OldTimePickerDisplayMode;
  /** @deprecated hasRemoveButton을 대신 사용해주세요. */
  showRemoveButton?: boolean;
}

export interface OldTimeRangePickerProps
  extends Omit<TimeRangePickerNewProps, 'status' | 'displayMode' | 'hasRemoveButton'> {
  /** @deprecated status를 대신 사용해주세요. */
  error?: boolean;
  /** @deprecated displayMode='bottom-sheet'를 대신 사용해주세요. */
  displayMode?: OldTimePickerDisplayMode;
  /** @deprecated hasRemoveButton을 대신 사용해주세요. */
  showRemoveButton?: boolean;
}

function normalizeDisplayMode(displayMode?: OldTimePickerDisplayMode): TimePickerDisplayMode | undefined {
  return displayMode === 'bottomSheet' ? 'bottom-sheet' : displayMode;
}

export function convertOldTimePickerProps(props: OldTimePickerProps): TimePickerNewProps {
  const { error, displayMode, showRemoveButton, ...restProps } = props;
  return {
    ...restProps,
    status: error ? 'error' : undefined,
    displayMode: normalizeDisplayMode(displayMode),
    hasRemoveButton: showRemoveButton,
  };
}

export function convertOldTimeRangePickerProps(props: OldTimeRangePickerProps): TimeRangePickerNewProps {
  const { error, displayMode, showRemoveButton, ...restProps } = props;
  return {
    ...restProps,
    status: error ? 'error' : undefined,
    displayMode: normalizeDisplayMode(displayMode),
    hasRemoveButton: showRemoveButton,
  };
}
